export default __webpack_public_path__ + "static/media/btc.82491fef.png";